function thamarSlide(sectionId, dir){
  var root = document.getElementById('hero-' + sectionId);
  if(!root) return;
  var slides = root.querySelectorAll('.hero-slide');
  var dots = root.querySelectorAll('.hero-slider__dot');
  var current = 0;
  slides.forEach(function(s,i){ if(s.classList.contains('is-active')) current = i; });
  var next = (current + dir + slides.length) % slides.length;
  thamarSlideTo(sectionId, next);
}
function thamarSlideTo(sectionId, index){
  var root = document.getElementById('hero-' + sectionId);
  if(!root) return;
  var slides = root.querySelectorAll('.hero-slide');
  var dots = root.querySelectorAll('.hero-slider__dot');
  slides.forEach(function(s,i){ s.classList.toggle('is-active', i === index); });
  dots.forEach(function(d,i){ d.classList.toggle('is-active', i === index); });
}
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.hero-slider').forEach(function(root){
    var slides = root.querySelectorAll('.hero-slide');
    if(slides.length > 1){
      var id = root.id.replace('hero-','');
      setInterval(function(){ thamarSlide(id, 1); }, 6000);
    }
  });
});
